const WebInputField = Object.freeze({
  TOGGLEBUTTON: 'toggle-button',
  CHECKBOX: 'checkbox',
  TEXTAREA: 'text-area',
});

const TypesFieldEnum = Object.freeze({
  SELECTION: 'selection',
  TEXT: 'text',
  NUMBER: 'number',
  INTEGER: 'integer',
  EMAIL: 'email',
  DATE: 'date',
  BIRTH_DATE: 'birth_date',
  TEL: 'tel',
  SSN: 'ssn',
  ADDITIONAL_ADDRESS: 'additional_address',
  MULTISELECTION: 'multiselection',
  PERCENTAGE: 'percentage',
});

const RoleField = Object.freeze({
  READ: 'read',
  WRITE: 'write',
  HIDDEN: 'hidden',
});

export { WebInputField, TypesFieldEnum, RoleField };
